import { render, staticRenderFns } from "./ActivitySelector.vue?vue&type=template&id=3bea0b30&scoped=true"
import script from "./ActivitySelector.vue?vue&type=script&lang=js"
export * from "./ActivitySelector.vue?vue&type=script&lang=js"
import style0 from "./ActivitySelector.vue?vue&type=style&index=0&id=3bea0b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea0b30",
  null
  
)

export default component.exports